import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { registerServiceWorker } from './sw-register.js';
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('#root tidak dijumpai');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
